import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/romance', label: '恋爱' },
    { to: '/category/fantasy', label: '奇幻' },
    { to: '/category/action', label: '动作' },
    { to: '/category/mystery', label: '悬疑' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50 shadow-sm' : 'bg-transparent'}`}>
      <nav className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 bg-primary-500 rounded-full flex items-center justify-center">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl text-foreground-900">{siteInfo.name}</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 hover:text-primary-500 ${location.pathname === link.to ? 'text-primary-500 font-medium' : 'text-foreground-700'}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 cursor-pointer transition-colors" aria-label="搜索">
              <i className="ri-search-line text-foreground-700 text-lg"></i>
            </button>
            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 px-5 py-2 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-up-line text-sm"></i>
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-foreground-700 text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 py-4 px-6">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`block py-2.5 text-sm cursor-pointer transition-colors hover:text-primary-500 ${location.pathname === link.to ? 'text-primary-500 font-medium' : 'text-foreground-700'}`}
            >
              {link.label}
            </Link>
          ))}
          <div className="mt-3 pt-3 border-t border-background-200">
            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 px-5 py-2 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-up-line text-sm"></i>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}